import React from "react";
import { Box, Typography } from "@mui/material";

const rubikfont = { fontFamily: "Rubik, sans-serif" };

// One heading style for every home section: gold kicker, serif title and a "View all" pill.
const SectionHeading = ({ kicker, title, actionLabel = "View all", onAction, sx }) => (
  <Box sx={{ mb: { xs: 2, md: 2.5 }, display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 2, ...sx }}>
    <Box>
      {kicker && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
          <Box sx={{ width: 22, height: "2px", bgcolor: "#C8A054", borderRadius: 1 }} />
          <Typography sx={{ fontSize: "11px", fontWeight: 600, letterSpacing: "3px", color: "#C8A054", textTransform: "uppercase", ...rubikfont }}>
            {kicker}
          </Typography>
        </Box>
      )}
      <Typography sx={{ fontSize: { xs: "22px", sm: "28px" }, fontWeight: 800, color: "#111", fontFamily: "'Playfair Display', serif", lineHeight: 1.1 }}>
        {title}
      </Typography>
    </Box>
    {onAction && (
      <Box
        onClick={onAction}
        sx={{
          flexShrink: 0,
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          px: { xs: 1.5, sm: 2 },
          py: 0.6,
          borderRadius: "999px",
          border: "1px solid #e8dcc2",
          bgcolor: "#fff",
          color: "#111",
          fontSize: { xs: "11px", sm: "12px" },
          fontWeight: 600,
          letterSpacing: "1.2px",
          textTransform: "uppercase",
          cursor: "pointer",
          transition: "all .2s",
          "&:hover": { bgcolor: "#C8A054", borderColor: "#C8A054", color: "#fff" },
          ...rubikfont,
        }}
      >
        {actionLabel} <span>→</span>
      </Box>
    )}
  </Box>
);

export default SectionHeading;
